import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

function getShortenMessage(message) {
  const { config } = DepsService.$ngRedux.getState();
  const { messageMaxPreviewTextLength } = config;
  const messageText = appHelpers.trimHtml(message);

  if (messageText.length > messageMaxPreviewTextLength) {
    return `${messageText.substr(0, messageMaxPreviewTextLength)}...`;
  }
  return messageText;
}

export default {
  getShortenMessage,
};



// WEBPACK FOOTER //
// ./src/modules/message/message-helpers.js